import { Button } from '@mr-yum/frontend-ui'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { useLogger } from '@/hooks/useLogger'

interface Props {
  venueSlug: string
}

export const BookNowButton = (_props: Props) => {
  const { logEvent } = useLogger()
  return (
    <Button
      type="button"
      variant="primary-alternative"
      onClick={() => {
        logEvent('Clicked on Booking')
      }}
      fullWidth
    >
      <FormattedMessage defaultMessage="Make a booking" id="ZIbSua" />
    </Button>
  )
}
